export enum SystemLocales {
  en = 'en-US',
  lt = 'lt-LT',
  lv = 'lv-LV',
  ee = 'ee-EE',
  ru = 'ru-RU',
}
